"use strict";
exports.__esModule = true;
exports.FlexAnywhereDdaOrVcExperiment = exports.FlexAnywhereDdaOrVcExperimentVariantValues = void 0;
// Used in RXP only
var FlexAnywhereDdaOrVcExperimentVariantValues;
(function (FlexAnywhereDdaOrVcExperimentVariantValues) {
    FlexAnywhereDdaOrVcExperimentVariantValues["DDA"] = "dda";
    FlexAnywhereDdaOrVcExperimentVariantValues["VC"] = "vc";
})(FlexAnywhereDdaOrVcExperimentVariantValues = exports.FlexAnywhereDdaOrVcExperimentVariantValues || (exports.FlexAnywhereDdaOrVcExperimentVariantValues = {}));
exports.FlexAnywhereDdaOrVcExperiment = {
    variantID: 'rxp-flex-anywhere-dda-or-vc',
    controlValue: FlexAnywhereDdaOrVcExperimentVariantValues.VC,
    variantValues: FlexAnywhereDdaOrVcExperimentVariantValues
};
